<template>
  <div class="bg-white mt-5 mx-2">
    <div class="inline-block w-full">
      <div class="text-center uppercase py-2">
        {{ title }}
      </div>
      <div class="flex flex-col">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitledCardBase",
  props: {
    title: {
      default: "",
      type: String
    }
  }
};
</script>

<style scoped></style>
